import Raf from './Raf'

const raf = new Raf()

export default {
    name: 'core-raf',

    created() {
        this.raf = raf
    },

    mounted() {
        if (this.onFrame) {
            this._mixinRafDispatcher = this.onFrame.bind(this)
            this.raf.addOnFrame(this._mixinRafDispatcher)
        } else {
            // console.warn('Use the method onFrame(deltaTime /* ms */, time /* ms */) if you use the mixin core-raf')
        }
    },

    destroyed() {
        if (this._mixinRafDispatcher) {
            this.raf.removeOnFrame(this._mixinRafDispatcher)
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/mixins/core-raf/index.js